(function ($, Drupal,  drupalSettings, once) {
  'use strict';

    Drupal.eu_cookie_compliance = Drupal.eu_cookie_compliance || function () {
    (Drupal.eu_cookie_compliance.queue = Drupal.eu_cookie_compliance.queue || []).push(arguments)
  };


  Drupal.behaviors.stage = {
    attach: function (context, settings) {
      const $elements = $(once('stage', '.stage__img', context));
      $elements.each(Drupal.behaviors.stage.init);
    },
    init: function (i, element) {
      objectFitImages();
    }
  };

  Drupal.behaviors.ytConsentIntegration = {
    attach: function (context, settings) {
      $(document).ready(function () {
        Drupal.behaviors.ytConsentIntegration.loadBlockedIframes();
        let buttons = document.querySelectorAll('.consent-agree-yt');
        buttons.forEach(button => {
          button.addEventListener('click', function() {
            var cats = Drupal.eu_cookie_compliance.getAcceptedCategories();
            cats.push('youtube');
            Drupal.eu_cookie_compliance.setAcceptedCategories(cats);
            Drupal.eu_cookie_compliance.changeStatus(2);
            Drupal.behaviors.ytConsentIntegration.loadBlockedIframes();

          });
        });

        let ytDivs = document.querySelectorAll('.yt-video-embed');
        ytDivs.forEach(ytDiv => {
          ytDiv.style.opacity = 1;
        });
        $('.eu-cookie-withdraw-button').click(Drupal.eu_cookie_compliance.withdrawAction);
      });
    },
    loadBlockedIframes: function (){
      const matches = document.querySelectorAll("iframe[eu-cookie-compliance-src]");
      if (matches.length > 0) {
        matches.forEach((element) => {
          element.src = "";
        });
        if( typeof Drupal.eu_cookie_compliance.getAcceptedCategories === 'function'){
          var cookieCategories = Drupal.eu_cookie_compliance.getAcceptedCategories();
        }else{ //if eu_cookie_compliance is not installed
          var cookieCategories = ["youtube"];
        }
        if (cookieCategories.includes("youtube")) {
          matches.forEach((element) => {
            element.src = element.getAttribute("eu-cookie-compliance-src");
            Drupal.behaviors.ytConsentIntegration.removeConsentBlocker(element.parentElement);
          });
        }
      }
    },
    removeConsentBlocker: function (element){
      let consentMessage = element.querySelector('.consent-contentblock--message');
      if (consentMessage) {
        consentMessage.remove();
      }
      let youtubePreview = element.querySelector('.yt-preview-image');
      if(youtubePreview){
        youtubePreview.remove()
      }
    }
  };

  Drupal.behaviors.sticky_head = {
    attach: function (context, settings) {
      $(once('sticky_head', 'body:not(.user-logged-in) .site-header', context)).each(Drupal.behaviors.sticky_head.init);
    },
    init: function (i, element) {

      $(window).scroll(function () {
        if ($(this).scrollTop() >= 60) {
          $('body:not(.user-logged-in) .site-header').addClass('sticky');
        } else {
          $('body:not(.user-logged-in) .site-header').removeClass('sticky');
        }
      });
    }
  };


  Drupal.behaviors.autosticky = {
    attach: function (context, settings) {
      //observe autosticky elements and add class when stuck
      $('.autosticky.observed').each(function () {
        var $sticky = $(this),
          $stickyprobe = $('<div class="stickyprobe"></div>').insertBefore($sticky),
          delta = function () {
            return $sticky.offset().top - $stickyprobe.offset().top;
          },
          normaldelta = $sticky.attr('delta') || 1;

        $(document).on('scroll', function () {
          if (delta() > normaldelta) {
            $sticky.addClass('stuck');
          } else {
            $sticky.removeClass('stuck');
          }
        });
      });
    }
  };

  Drupal.behaviors.externalLinks = {
    attach: function attach(context, settings) {
      $('a').each(function () {
        /** open all external links in a new tab **/
        var excludeClasses = ["chosen-single", "search-choice-close"];
        if (this.getAttribute("class") && excludeClasses.some(word => this.getAttribute("class").includes(word))) {
          //exclude links set by chosen!
          return;
        }
        var a = new RegExp('/' + window.location.host + '/');

        if (!a.test(this.href)) {

          $(this).click(function (event) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, '_blank');
          });
        }
      });
    }
  };

  Drupal.behaviors.gridViews = {
    attach: function attach(context, settings) {


      const gridItems = document.querySelectorAll('.views-view-responsive-grid__item');

      const loadImages = () => {
        gridItems.forEach(item => {

          if (true  && !item.classList.contains('loaded')) {
          // if (true) {
            const img = item.querySelector('img');
            if (img) {
              const imgSrc = img.getAttribute('data-src'); // Assuming data-src attribute holds the actual image URL
              // Timeout to force visibility after 5 seconds
              let timeoutId = setTimeout(() => {
                item.style.opacity = '1';
                item.classList.add('loaded'); // Mark as loaded even if image hasn't loaded
              }, 3501); // 5000 milliseconds = 5 seconds

              img.onload = function () {
                clearTimeout(timeoutId); // Clear the timeout if the image loads in time
                item.style.opacity = '1';
                item.classList.add('loaded');
              };
              img.onerror = function () {
                clearTimeout(timeoutId); // Clear the timeout if there is an error loading the image
                item.style.opacity = '1';
                item.classList.add('loaded');
              };
              img.setAttribute('src', imgSrc);
            } else {
              // If there is no img element, make the grid item visible immediately
              item.style.opacity = '1';
              item.classList.add('loaded');
            }

          }
        });
      };

      // Initial check
      loadImages();

      // Check on scroll
      window.addEventListener('scroll', loadImages);


      function isInViewport(element, offset = 100) { // Offset of 100 pixels before the element comes into view
        const rect = element.getBoundingClientRect();
        return (
          rect.top >= (0 - offset) &&
          rect.left >= (0 - offset)
          &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) + offset
        );
      }
    }
  };


}(jQuery,Drupal, drupalSettings, once));
